export class DealState {
    uid: string;
    openCreateDealModal: boolean;
    constructor() {
        this.uid = null;
        this.openCreateDealModal = false;
    }
}